import { Observable } from 'rxjs';
import type {
  ExtendedApiResponse,
  SupportedCoinsRequest,
  SupportedTokensResponse,
} from '@coin-depo-types';

export interface TokenApi {
  getSupportedTokens(
    data: SupportedCoinsRequest
  ): Observable<ExtendedApiResponse<SupportedTokensResponse>>;
}